// Validation constrain codes. Present in a BAD_USER_INPUT GraphQL error
enum Constrains {
  // Occurs when user email domain in the black list
  IsCustomEmailDomain = 'IsCustomEmailDomain',
  isMobilePhone = 'isMobilePhone',
  isEnum = 'isEnum',
}

export { Constrains };
